import View from '../../View'
import {AccessRights} from '../../constants'

export default class APAccessRightsChecker extends View {
    constructor() {
        super()

        this.state = {

        }
    }

    hasManageLicenceRight(user) {
        return this._hasRightRegardlessFeature(user, AccessRights.AP_MANAGE_GENERAL_SETTINGS)
    }

    _hasRightRegardlessFeature(user, accessRight) {
        return user.accessRights.indexOf(accessRight) !== -1
    }
}


// WEBPACK FOOTER //
// ./web/js/util/productAccessRightsChecker/APAccessRightsChecker.js